import { queryClient } from '@raystack/frontier/react';
import * as Sentry from '@sentry/browser';

import store from '../redux/store';

import { logoutUser } from '../redux/_reducers/authReducer';
import { logout } from './apis/FrontierApis';
import { isAuthRoute } from './auth';
import { AUTH_ROUTES, ROUTES } from './constants/Routes';
import { clearPreLoginRoute, saveCurrentRouteForLogin } from './storage';

export async function LogoutUser(navigate = null, clearPreviousRoute = false) {
  await logout();

  // Clear TanStack Query cache to remove stale user data
  queryClient.clear();

  store.dispatch(logoutUser());
  const currentPath = window.location.pathname;

  // Store current route for post-login redirect
  if (clearPreviousRoute) {
    clearPreLoginRoute();
  } else {
    const currentRoute = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (!isAuthRoute(currentRoute)) {
      saveCurrentRouteForLogin(currentRoute);
    }
  }

  Sentry.setUser(null);
  if (navigate !== null) {
    navigate(`/${ROUTES.LOGIN}`);
  } else if (!AUTH_ROUTES.includes(currentPath)) {
    window.location.href = `/${ROUTES.LOGIN}`;
    window.location.reload();
  }
}
